/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react'
import { FormLabel, FormText } from 'react-bootstrap'
import Select, { StylesConfig, GroupBase } from 'react-select'
import { components } from 'react-select'
import CreatableSelect from 'react-select/creatable'
import { ATDropdownProps } from './FormComponentProps'

const Option: any = (props: any) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{' '}
        <label>{props.label}</label>
      </components.Option>
    </div>
  )
}

const MultiValueContainer: any = (props: any) => {
  const label = props.data.label
  const allSelected = props.selectProps.value
  const index = allSelected.findIndex(
    (selected: any) => selected.label === label,
  )
  const isLastSelected = index === allSelected.length - 1
  const labelSuffix = isLastSelected ? '' : ', '
  const val = `${label}${labelSuffix}`
  return props?.selectProps?.menuIsOpen ? null : val
}

const ATDropdown: React.FC<ATDropdownProps> = ({
  name,
  options,
  isMulti = false,
  isSearchable = true,
  isCreatable = false,
  isGrouped = false,
  placeholder = 'Select',
  onChange,
  value,
  labelKey = 'label',
  valueKey = 'value',
  onBlurHandler = () => {
    console.log('')
  },
  title,
  isError,
  error,
  isMandatory = true,
  isCustomValue = false,
  isCustomLabel = false,
  onCreateOption = () => {},
  getCustomLabel = () => {},
  getCustomValue = () => {},
  disabled = false,
  isClearable = true,
  createNewLabel = 'Create new',
  closeMenuOnSelect = true,
  hideSelectedOptions = true,
  defaultValue,
}) => {
  const SelectComponent = isCreatable ? CreatableSelect : Select
  const customStyles: StylesConfig<unknown, false, GroupBase<unknown>> = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isFocused ? 'black' : 'inherit',
      backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
    }),
    control: (provided) => ({
      ...provided,
      color: 'black',
    }),
    valueContainer: (provided, state) => {
      return isMulti
        ? {
            ...provided,
            textOverflow: 'ellipsis',
            maxWidth: '90%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            display: `${state.hasValue ? 'initial' : 'flex'}`,
            flexWrap: 'nowrap',
          }
        : { ...provided }
    },
  }

  return (
    <div>
      {title && (
        <FormLabel className="text-start w-100 pt-2">
          <span>{title}</span>
          {isMandatory && <span className="text-danger">*</span>}
        </FormLabel>
      )}
      <SelectComponent
        className="react-select-container"
        classNamePrefix="react-select"
        menuPlacement={'auto'}
        styles={customStyles}
        options={options}
        isMulti={isMulti}
        components={isMulti ? { Option, MultiValueContainer } : {}}
        delimiter={','}
        isSearchable={isSearchable}
        placeholder={placeholder}
        isDisabled={disabled}
        isClearable={isClearable}
        closeMenuOnSelect={closeMenuOnSelect}
        hideSelectedOptions={hideSelectedOptions}
        defaultValue={defaultValue}
        onBlur={() => {
          onBlurHandler({ target: { name: name } })
        }}
        onChange={(opt) => {
          if (isMulti) {
            onChange(opt)
          } else if (isGrouped) {
            onChange(opt?.[valueKey])
          } else if (isCustomValue) {
            onChange(getCustomValue(opt))
          } else {
            onChange(opt?.[valueKey])
          }
        }}
        value={
          isGrouped
            ? options?.find((option: any) => {
                return option?.[valueKey] === value
              })
            : options?.filter((option: any) => {
                if (isMulti) {
                  for (let i = 0; i < value?.length; i++) {
                    const element: any = value[i]
                    if (element[valueKey] === option?.[valueKey]) {
                      return true
                    }
                  }
                  return false
                } else if (isCustomValue) {
                  const selectedOption = options?.find((option: any) => {
                    return getCustomValue(option) === value
                  })
                  return selectedOption ? true : false
                } else {
                  return option?.[valueKey] === value
                }
              })
        }
        getOptionLabel={(option) => {
          if (isCustomLabel) {
            return getCustomLabel(option)
          }
          if (option.__isNew__) {
            return option.label
          }
          return option[labelKey]
        }}
        getOptionValue={(option) => {
          if (isCustomValue) {
            return getCustomValue(option)
          }
          if (option.__isNew__) {
            return option.value
          }
          return option[valueKey]
        }}
        onCreateOption={(newValue) => {
          if (isCreatable) {
            onCreateOption(newValue)
          }
        }}
        formatCreateLabel={(inputValue) => {
          return `${createNewLabel} "${inputValue}"`
        }}
      />
      <FormText className="text-danger">{isError && error}</FormText>
    </div>
  )
}

export default ATDropdown
